const colors = [
  '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#16a085', '#27ae60', '#2980b9', '#8e44ad', '#2c3e50',
  '#f1c40f', '#e67e22', '#e74c3c', '#ecf0f1', '#95a5a6', '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d',
  '#cd84f1', '#ffcccc', '#ff4d4d', '#ffaf40', '#fffa65', '#c56cf0', '#ffb8b8', '#ff3838', '#ff9f1a', '#fff200',
  '#32ff7e', '#7efff5', '#18dcff', '#7d5fff', '#3ae374', '#67e6dc', '#17c0eb', '#7158e2'
];

export default colors;
